<template>
  <div id="modalDetailsTicket" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Detalhes do Ticket {{ ticketId }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <div class="modal-body pb-1">
          <div class="row">
            <div class="col-sm-6">
              <p><strong>ID: </strong>{{ ticket.ticketId }}</p>
            </div>
            <div class="col-sm-6">
              <p>
                <strong>Data de Criação: </strong>
                {{ convertTimestampToBrazilianDate(ticket.createTime) }}
              </p>
            </div>
            <div class="col-sm-6">
              <p><strong>Solicitante: </strong> {{ ticket.requester }}</p>
            </div>
            <div class="col-sm-6">
              <p><strong>Técnico: </strong> {{ ticket.technicianName }}</p>
            </div>
            <div class="col-sm-12">
              <p><strong>Cliente: </strong> {{ ticket.organization }}</p>
            </div>
            <div class="col-sm-12">
              <p><strong>Título: </strong> {{ ticket.summary }}</p>
            </div>
            <div class="col-sm-12">
              <p><strong>Descrição: </strong> {{ ticket.description }}</p>
            </div>
            <div class="col-sm-6">
              <p>
                <strong>Tempo Total: </strong>
                {{ convertSecondsToHours(ticket.totalTimeTracked) }}
              </p>
            </div>
            <div class="col-sm-6">
              <p>
                <strong>Última Sincronização: </strong>
                {{ dateTimeSqlToDateTimeBR(ticket.lastSync) }}
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer border-top-0">
          <button
            type="button"
            class="btn btn-link"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showModal } from '@/utils/modal'
import {
  convertTimestampToBrazilianDate,
  convertSecondsToHours,
  dateTimeSqlToDateTimeBR,
} from '@/utils/date'

export default {
  name: 'DetailsTicketModal',

  props: {
    ticketId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      ticket: {},
      convertTimestampToBrazilianDate,
      convertSecondsToHours,
      dateTimeSqlToDateTimeBR,
    }
  },

  methods: {
    async getTicket() {
      try {
        this.ticket = await this.$store.dispatch('getTicket', this.ticketId)
        showModal('modalDetailsTicket')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },
  },

  mounted() {
    this.getTicket()
  },
}
</script>
